import React from 'react';
import './App.css';
import './fonts/cyrillic-raleway.css';
import {MuiPickersUtilsProvider} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import {GoogleOAuthProvider} from '@react-oauth/google';
import ruLocale from "date-fns/locale/ru";
import format from "date-fns/format";
import prepareStores from "./app/store";
import {createBrowserHistory} from 'history';
import {Provider} from 'mobx-react';
import MainRouter from "./app/router";
import 'mobx-react-lite/batchingForReactDom'

const history = createBrowserHistory();

const stores = prepareStores(history);

class RuLocalizedUtils extends DateFnsUtils {
    getCalendarHeaderText(date) {
        return format(date, "LLLL", {locale: this.locale});
    }

    getDatePickerHeaderText(date) {
        return format(date, "dd MMMM", {locale: this.locale});
    }
}

const App = props => (
    <GoogleOAuthProvider clientId="450306916139-oit3l6ak0bqufu7l24hpa3djinumr3cf.apps.googleusercontent.com">
        <Provider {...stores}>
            <MuiPickersUtilsProvider locale={ruLocale} utils={RuLocalizedUtils}>
                <MainRouter>
                    {props.children}
                </MainRouter>
            </MuiPickersUtilsProvider>
        </Provider>
    </GoogleOAuthProvider>
);

export default App;
